import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/indexHome.vue'),
    children: [
      {
        path: '/',
        name: 'myIndex',
        component: () => import('../views/myIndex.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
